import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import PostApi from '../../../api/PostApi';
import { TodayTimestampDisplay } from '../../common/TimestampDisplay';
import { getPostBaseUrl, getPostCategoryColor, getPostCategoryName } from '../../../constant/PostClass';
import { isToday } from 'date-fns';
import { resolvePostThumbnailUrl } from '../../../util/ImageService';

const TABS = [
    { tab_type: 'PT01', label : '커뮤니티'},
    { tab_type: 'PT02', label : '인기정보'},
    { tab_type: 'PT03', label : '인기질문'},
    { tab_type: 'PT020', label : '정보공유'},
    { tab_type: 'PT030', label : '질문답변'},
    // { tab_type: 'PT001', label : '마케팅서비스'},
]

const getBaseUrl = type => {
    const postType = type.length === 5 ? type : type + '0';
    return getPostBaseUrl(postType);
}

const getRandomIdx = length => {
    return Math.floor(Math.random() * length);
};

const getRemovedTagContent = content => {
    return content
        .replace(/<[^>]*>?/g, '')
        .replace(/<[^>]*$/g, '') 
        .replace(/&nbsp;/g, ' ') 
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .replace(/\r\n/g, ' ')
        .replace(/\n/g, ' ')
        .replace(/\r/g, ' ')
        .replace(/\t/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
}

const TotalBoard = ({ tabList = TABS, api = PostApi.getTotalBoardPosts}) => {
    const navigate = useNavigate();
    const [tab, setTab] = useState(tabList[getRandomIdx(tabList.length)]);
    const [posts, setPosts] = useState([]);

    const handleTabChg = newTab => {
        setTab(newTab);
    }

    const handleTitleClick = post => {
        const baseUrl = getBaseUrl(post.post_type);
        navigate(`${baseUrl}/post/detail/${post.post_id}`);
    }

    const handleClickMore = () => {
        navigate(getBaseUrl(tab.tab_type));
    }

    useEffect(() => {
        const tabTypes = tabList.map(t => t.tab_type);
        api(3, tabTypes).then(data => {
            setPosts(data.posts);
        });
    }, [])

    return (
        <div className="section-area">
            <div className="section-tab-header">
                <ul className="section-tab-tablist">
                    {tabList.map((t) => 
                        <li
                            className={t.tab_type === tab.tab_type ? 'active' : ''} 
                            onClick={() => handleTabChg(t)}
                        >{t.label}</li>
                    )}
                </ul>
                <a className="pc-only" onClick={handleClickMore}>
                    <span>더보기</span>
                    <i className="icon icon-arrow-right-bold"></i>
                </a>
            </div>
            <div className="section-content">
                <div className="bbs-card-list">
                    <ul>
                        {posts.filter(p => p.tab_type === tab.tab_type).map(p => {
                            const thumbnailUrl = resolvePostThumbnailUrl(p);
                            return (
                            <li key={p.post_id}>
                                <a className="bbs-card" onClick={() => handleTitleClick(p)}>
                                    <div className="bbs-card-head">
                                        <div className={`bbs-card-badge ${getPostCategoryColor(p.post_type)}`}>
                                            {getPostCategoryName(p.post_type)}
                                        </div>
                                        <span className="pc-only">
                                            <TodayTimestampDisplay timestamp={p.date}/>
                                        </span>
                                    </div>
                                    <div className="bbs-card-body">
                                        <div className="bbs-card-text">
                                            <div className="bbs-card-subject els">{p.title}</div>
                                            <p className="els2">
                                                {getRemovedTagContent(p.content)}
                                            </p>
                                        </div>
                                        {thumbnailUrl && <div className="bbs-card-thumb mo-only">
                                            <img src={thumbnailUrl} alt="썸네일" />
                                        </div>}
                                    </div>
                                    <div className="bbs-card-meta">
                                        <span>{p.writer}</span>
                                        <span className="mo-only">
                                            <TodayTimestampDisplay timestamp={p.date}/>
                                        </span>
                                        <div className="icon_btn">
                                            <i className="icon icon-heart"></i>
                                            <span>{p.post_like_cnt || 0}</span>
                                        </div>
                                        <div className="icon_btn">
                                            <i className="icon icon-chat"></i>
                                            <span>{p.comment_cnt || 0}</span>
                                        </div>
                                        <div className="icon_btn">
                                            <i className="icon icon-eye"></i>
                                            <span>{p.post_visit || 0}</span>
                                        </div>
                                    </div>
                                </a>
                            </li>
                            );
                        })}
                    </ul>
                </div>
            </div>
            <div className="btn">
                <span>더보기</span>
                <i className="icon icon-gray icon-arrow-right-bold"></i>
            </div>
        </div>
    )
}

const CardBoard = ({ type='', posts = [], icon = '', title = '' }) => {
    const navigate = useNavigate();
    const handleTitleClick = post => {
        const baseUrl = getBaseUrl(post.post_type);
        navigate(`${baseUrl}/post/detail/${post.post_id}`);
    }
    const handleClickMore = () => {
        navigate(getBaseUrl(type));
    }

    return (
        <div className="section-area">
            <div className="section-header">
                <i className={`icon ${icon}`}></i>
                <h1 className="section-header-title">{title}</h1>
                <a onClick={handleClickMore} title="더보기">
                    <span>더보기</span>
                    <i className="icon icon-black icon-arrow-right"></i>
                </a>
            </div>
            <div className="section-content">
                <table className="bbs-list-table">
                    <colgroup>
                        <col width="" />
                        <col width="80px" />
                    </colgroup>
                    <tbody>
                        {posts.map(p => 
                            <tr key={p.post_id}>
                                <td>
                                    <a onClick={() => handleTitleClick(p)}>
                                        <div className="subject">
                                            <p>{p.title}</p>
                                            {p.comment_cnt > 0 && <div className="badge">{p.comment_cnt}</div>}
                                        </div>
                                        <p className="desc">{getRemovedTagContent(p.content)}</p>
                                    </a>
                                </td>
                                <td>
                                    <div className="bbs-list-etc mobile-only">
                                        <i className="icon icon-20 icon-profile"></i>
                                        <span>{p.writer}</span>
                                    </div>
                                    <div className="bbs-list-etc">
                                        <i className="icon icon-12 icon-eye"></i>
                                        <span>{p.post_visit}</span>
                                    </div>
                                    <div className="bbs-list-etc mobile-only">
                                        <span><TodayTimestampDisplay timestamp={p.date}/></span>
                                    </div>
                                    <div className="bbs-list-etc mobile-only">
                                        <i className="icon icon-12 icon-chat"></i>
                                        <span>{p.comment_cnt || 0}</span>
                                    </div>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
            <div className="btn" onClick={handleClickMore}>
                <span>더보기</span>
                <i className="icon icon-black icon-arrow-right"></i>
            </div>
        </div>
    )
}

export default TotalBoard;
export { CardBoard };